import { create } from 'zustand';
import api from '../api/client';

interface User {
  id: number;
  username: string;
  email?: string;
  first_name?: string;
  last_name?: string;
  is_staff: boolean;
}

interface Permissions {
  is_super_admin: boolean;
  is_admin: boolean;
  role_name: string | null;
}

interface AuthState {
  user: User | null;
  isSuperAdmin: boolean;
  token: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (username: string, password: string) => Promise<void>;
  logout: () => void;
  checkAuth: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  user: null,
  isSuperAdmin: false,
  token: localStorage.getItem('admin_token'),
  isAuthenticated: !!localStorage.getItem('admin_token'),
  isLoading: false,

  login: async (username: string, password: string) => {
    set({ isLoading: true });
    localStorage.removeItem('admin_token');
    delete api.defaults.headers.common['Authorization'];
    try {
      const response = await api.post('/auth/', { username, password });
      const { token, permissions } = response.data;
      const perms: Permissions = permissions || {};

      if (!perms.is_super_admin) {
        set({ isLoading: false });
        throw new Error('Bu panel faqat super admin uchun. Sizda ruxsat yo\'q.');
      }

      localStorage.setItem('admin_token', token);
      api.defaults.headers.common['Authorization'] = `Token ${token}`;

      set({
        user: response.data.user,
        isSuperAdmin: true,
        token,
        isAuthenticated: true,
        isLoading: false,
      });
    } catch (error: any) {
      set({ isLoading: false });
      if (error.message && !error.response) throw error;
      const data = error.response?.data || {};
      throw new Error(data.error || data.detail || 'Login xatosi');
    }
  },

  logout: () => {
    localStorage.removeItem('admin_token');
    delete api.defaults.headers.common['Authorization'];
    set({ user: null, isSuperAdmin: false, token: null, isAuthenticated: false });
  },

  checkAuth: async () => {
    const token = get().token;
    if (!token) {
      set({ isAuthenticated: false, isLoading: false });
      return;
    }
    set({ isLoading: true });
    try {
      const response = await api.get('/auth/');
      const perms = response.data.permissions || {};
      if (!perms.is_super_admin) {
        throw new Error('not super admin');
      }
      set({
        user: response.data,
        isSuperAdmin: true,
        isAuthenticated: true,
        isLoading: false,
      });
    } catch {
      localStorage.removeItem('admin_token');
      delete api.defaults.headers.common['Authorization'];
      set({ user: null, isSuperAdmin: false, token: null, isAuthenticated: false, isLoading: false });
    }
  },
}));
